let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hp6cH")).then(() => parcelRequire('ed6qk'));